import { styled } from '@lichtblick/styled';
import { Spacing } from '@lichtblick/theme';

export const IdContainer = styled.div`
  margin: ${Spacing.Xxs} 0px;
`;

export const ChipContainer = styled.div`
  margin-top: ${Spacing.Xs};
`;
